module.exports = __webpack_public_path__ + "img/left-arrow.3b3acf8b.svg";